import api from '../api';

const baseContext = `${process.env.REACT_APP_API_URL_LOCAL}/api/v1/worker/work_field`;

// eslint-disable-next-line import/no-anonymous-default-export
export const getAllRubros = () => {
  return api.get(`${baseContext}/list`);
};
